import type { AlertAppearance } from '@ksyos/design-system';
import type { JSX } from 'react';
import { Alert } from '@ksyos/design-system';
import type { BariPreMedConsultAssessmentData } from '@common/validation/customControls/bariPre/bariPreMedConsultAssessment/v1/bariPreMedConsultAssessmentSchemaV1';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { MedConsultAssessmentAdvice } from '@common/customControls/bariatrics';
import { ProcessActivityStatus } from '@common/enums';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useProcessActivityReadContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { addInclusieInZorgpadComponent } from '../../../bariatrics/readFormComponents';
import { medConsultAssessmentAdviceWithColor } from './bariPreMedConsultAssessmentUtils';

export function BariPreMedConsultAssessmentRead(): JSX.Element {
    const { processActivity, readSections } = useProcessActivityReadContext<BariPreMedConsultAssessmentData>();
    const { status, customControlData } = processActivity;

    return (
        <>
            <ReadForm components={getComponents()} />
            {status === ProcessActivityStatus.complete &&
                getMedConsultAssessmentAdviceAlert(customControlData.inclusie_in_zorgpad)}
        </>
    );

    function getComponents(): ComponentsMap {
        const map: ComponentsMap = new Map();
        addInclusieInZorgpadComponent<BariPreMedConsultAssessmentData>(
            readSections,
            medConsultAssessmentAdviceWithColor,
            map
        );

        return map;
    }
}

function getMedConsultAssessmentAdviceAlert(
    medConsultAssessmentAdvice: MedConsultAssessmentAdvice | null
): JSX.Element | null {
    if (!medConsultAssessmentAdvice || medConsultAssessmentAdvice === MedConsultAssessmentAdvice.include) {
        return null;
    }

    const [appearance, text]: [AlertAppearance, string] =
        medConsultAssessmentAdvice === MedConsultAssessmentAdvice.mdo
            ? ['warning', 'De patiënt moet besproken worden in het MDO']
            : [
                  'info',
                  'De patiënt wordt niet geïncludeerd in het zorgpad. Er is een bericht naar de huisarts gestuurd.',
              ];

    return <Alert appearance={appearance}>{text}</Alert>;
}
